export const APIPath = {
  account: 'account',
  accountOrganization: 'account/organization',
  allocation: 'allocation',
  billingBaseTemplate: 'billing/base-templates',
  billingMetadata: 'billing/metadata',
  billingCustomerTemplates: 'billing/customer-templates',
  billingInvoices: 'billing/invoices',
  billingDraft: 'billing/invoices/draft',
  billingInvoiceBulkQuickBookExport: 'billing/invoices/bulk/quickbooksExport',
  billingLabelRate: 'billing/label-rate-margin',
  billingQuickbookConfig: 'billing/quickbooks-config',
  customers: 'customers',
  customerHoldStatus: 'billing/customer-hold-status',
  containerTotes: 'containers/totes',
  containerTotesTemplate: 'containers/totes/template',
  containerTotesGenerateUrl: 'containers/totes/generateUrl',
  containerTotesFeeds: 'containers/totes/feeds',
  containerPalletsTemplate: 'pallets/feeds/template',
  containerPalletsGenerateUrl: 'pallets/feeds/generateUrl',
  containerPalletsFeeds: 'pallets/feeds',
  exportOrganization: 'dashboards/exports/detailed',
  containersLimboState: 'containers/checkLimboState',
  containerReset: 'containers/reset',
  inventory: 'inventory',
  inventoryItems: 'inventory/items',
  inventoryExport: 'inventory/export',
  inventoryExportFeeds: 'inventory/export/feeds',
  inventoryExportFeed: 'inventory/export/feed',
  inventoryStockAlerts: 'inventory/stockAlerts',
  inventoryStockAlertsConsolidated: 'inventory/stockAlerts/consolidated',
  inventoryExportConsolidated: 'inventory/stockAlerts/consolidated/export',
  items: 'items',
  initResetPassword: 'auth/password/reset-request',
  warehouseEmailConfig: 'warehouses/emailWaveConfig',
  resetPassword: 'auth/password/reset',
  inventoryFeed: 'inventory/feeds',
  inventoryItem: 'inventory/item',
  inventoryFeedUploadUrl: 'inventory/feeds/uploadUrl',
  inventoryProposals: 'inventory/proposals',
  ordersInventoryLocationsDropdown: 'orders/inventory-locations/dropdown',
  inventoryTransfers: 'inventory/transfers',
  inventoryTransfersSuggested: 'inventory/listSuggestedTransfers',
  inventorySuggestedTransfer: 'inventory/suggestedTransfers',
  inventorySuggestedTransfersRefresh: 'inventory/suggested-transfers/refresh',
  inventorySuggestedTransfersRefreshStatus:
    'inventory/suggested-transfers/refresh/status',
  inventoryReplenishmentWaves: 'inventory/replenishmentWaves',
  invites: 'invites',
  inventoryErpSkuSearch: 'inventory/erp/skuSearch',
  login: 'auth/login',
  handoff: 'auth/handoff',
  portalHandoff: 'auth/portal-handoff',
  locationMovePreview: 'locations/move/preview',
  locationMove: 'locations/move',
  locationsGenerateLabels: 'locations/generate-labels',
  manifestCarriers: 'manifest/carriers',
  manifestReport: 'manifest/report',
  mergeWaves: 'waves/merge',
  inventoryLocation: 'inventory/location',
  orderAllocationTote: 'orders/allocations/tote',
  orderAllocations: 'orders/allocations',
  orderAllocationsCancel: 'orders/allocations/cancel',
  orderTotes: 'orders/totes',
  orderWaveRules: 'orders/waveRules',
  orderWaveRulesMetadata: 'orders/waveRules/metadata',
  orderWaveRulesSkuSearch: 'orders/waveRules/skus/search',
  orderAllocationsPickingLocationSuggestions:
    'orders/allocations/picking-location-suggestions',
  orderAllocationsMoveLocationBatch: 'orders/allocations/move-location-batch',
  orderAllocationsUnassignedRefresh: 'orders/allocations/unassigned/refresh',
  orderAllocationsUnassignedRefreshStatus: 'orders/allocations/unassigned/refresh/status',
  orderAllocationsUnassignedBatchTransfer: 'orders/allocations/unassigned/batch-transfer',
  feeds: 'feeds',
  orderWaves: 'orders/waves',
  ordersWavesAllocationsBulkAdd: 'orders/waves/allocations/bulk-add',
  wavesAssign: 'waves/assign',
  wavesUnAssign: 'waves/unassign',
  exportOrderWaves: 'orders/waves/exports',
  waves: 'waves',
  orderWavesList: 'orders/waves/list',
  orderWavesSummary: 'orders/waves/summary',
  orders: 'orders',
  ordersTracking: 'orders/tracking',
  locationsFeeds: 'locations/feeds',
  locations: 'locations',
  inventoryTransferSourceLocations: 'inventory/transferSourceInventory',
  locationsFeedsGenerateUrl: 'locations/feeds/generateUrl',
  locationsFeedsTemplate: 'locations/feeds/template',
  ordersPackagingContainerContents: 'orders/packaging/container-contents',
  ordersPackagingContainers: 'orders/packaging/containers',
  scannerDiagnostics: 'orders/packaging/scanner-diagnostics',
  ordersPackagingContainersCompleted: 'orders/packaging/containers/completed',
  ordersPackagingTote: 'orders/packaging/tote',
  organizationDashboard: 'dashboards',
  organizationIntegration: 'organizations/integration',
  organizations: 'organizations',
  organizationsRegions: 'organizations/regions',
  organizationsLogoUrl: 'organizations/upload',
  organizationsSidebarMetadata: 'organizations/sidebar-metadata',
  packagingMaterials: 'packaging/packaging-materials',
  packagingLabel: 'packaging/label',
  packagingShippingRate: 'packaging/shipping/rate',
  packagingLabelCorrection: 'packaging/shipping/label/correction',
  publicAppVerion: 'public/app-version',
  public: 'public',
  packagingShippingLabel: 'packaging/shipping/label',
  pallets: 'pallets',
  palletsBulkCreate: 'pallets/bulk-create',
  palletsGenerateLabels: 'pallets/generate-labels',
  printLabel: 'orders/label/print',
  rackLocations: 'racks/locations',
  rackPresets: 'racks/rack-presets/list',
  rackTypes: '/racks/rack-types',
  racks: 'racks',
  racksLocationValidate: 'racks/locations/validate-location',
  refreshToken: 'auth/token/refresh',
  register: 'auth/register',
  requestEmailCode: 'auth/register/verify-email',
  shipments: 'shipments',
  shipmentsComment: 'shipments/comment',
  shipmentsDocumentsUploadUrl: 'shipments/documents/uploadUrl',
  shipmentsStatus: 'shipments/status',
  shipmentsUploadShipmentDocuments: 'shipments/uploadShipmentDocuments',
  sortedOrderWavesList: 'orders/allocations/sorted',
  users: 'users',
  totesBulkCreate: 'totes/bulk-create',
  totesGenerateLabels: 'totes/generate-labels',
  verifyLogin: 'auth/login/verify',
  warehouses: 'warehouses',
  generaetWaveNumber: 'waves/generateWaveNumber',
  wavesRulesList: 'orders/waveRules/list',
  zoneTypes: 'zones/types',
  zones: 'zones',
};
